import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./deaboStyle.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

export default function Deabo() {
    const navigate = useNavigate();

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    const [deaboState, setDeaboState] = useState(false);

    const hasRun = useRef(false);

    useEffect(() => {
        document.title = "DJ - EMAN"

        if (hasRun.current) return;
        hasRun.current = true;

        const emailParam = query.get("email");
        const uuidParam = query.get("uuid");

        deaboNewsletter(emailParam, uuidParam);
    }, []);

    const deaboNewsletter = async (emailParam, uuidParam) => {
        const deaboData = {
            email: emailParam,
            uuid: uuidParam,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/deabonewsletter", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(deaboData),
            });

            if (response.ok) {
                toast.success("Dein Newsletter-Abonnement wurde gekündigt");
                setDeaboState(true);
            } else {
                toast.error("Dein Newsletter-Abonnement konnte nicht gekündigt werden");
            }


        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    return (
        <div className="deaboContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>Schade das du dich hierfür entschieden hast</h1>
            <h2>Wir nutzen Newsletter um dich auf dem neuesten Stand zu halten und dich über neue Events zu informieren</h2>
            <h3>Dein Newsletter-Abonnement wird automatisch gekündigt</h3>
            {deaboState && (
                <h4>Du kannst die Seite jetzt schließen</h4>
            )}
        </div>
    )
}
